import { executeUsercase } from '@/app/executeUsercase';
import type { ResolvedData as ResolvedItemDetailsData } from '@/app/items/itemGetById';
import itemGetById from '@/app/items/itemGetById';
import Page from '@/interface/ui/t/[id]';
import type { RootState } from '@/store';
import { appFetchSucceeded } from '@/store/ducks/app/index';
import { itemDetailsLoadSucceeded } from '@/store/ducks/domain/itemDetails';
import type { NextPage, NextPageContext } from 'next';
import type { Store } from 'redux';

async function fetchAndStore(
  store: Store,
  {
    itemId,
    asPath,
  }: {
    itemId: number;
    asPath?: string;
  }
) {
  try {
    const itemDetailsData = await executeUsercase<
      ResolvedItemDetailsData,
      { itemId: number }
    >(itemGetById, {
      itemId,
    });

    store.dispatch(itemDetailsLoadSucceeded(itemDetailsData));
  } catch (error) {
    if (error?.details === 'NotFound') {
      return { statusCode: 404 };
    }
  }

  if (asPath === undefined) {
    return;
  }

  store.dispatch(appFetchSucceeded([asPath]));
}

(Page as NextPage).getInitialProps = async ({
  req,
  store,
  query,
  err,
  asPath,
}: NextPageContext & { store: Store<RootState> }) => {
  const itemId = Number(query.id);

  // パスに id が含まれていない時はエラー
  if (isNaN(itemId)) {
    return {
      statusCode: 404,
    };
  }

  const isServer = req !== undefined;
  if (isServer) {
    const response = await fetchAndStore(store, { itemId, asPath });

    if (response?.statusCode === 404) {
      return response;
    }

    return {
      namespacesRequired: ['common'],
    };
  }

  // isClient
  const { app } = store.getState();
  const { fetchedPaths } = app;
  if (!fetchedPaths.includes(asPath || 'none')) {
    const response = await fetchAndStore(store, { itemId, asPath });

    if (response?.statusCode === 404) {
      return response;
    }
  }
  return {};
};

export default Page;
